"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.DiscoverMitsubishiDefaultProps = exports.DiscoverMitsubishi = void 0;
var _discoverMitsubishi = _interopRequireDefault(require("./components/discover-mitsubishi"));
exports.DiscoverMitsubishi = _discoverMitsubishi["default"];
var _discoverMitsubishi2 = _interopRequireDefault(require("./components/discover-mitsubishi.props/discover-mitsubishi.defaultProps"));
exports.DiscoverMitsubishiDefaultProps = _discoverMitsubishi2["default"];